/**
 * Enum representing different status types for system or application states.
 *
 * @category InformationCard
 * @enum {string}
 */
export enum StatusType {
  /** Represents a successful or positive state. */
  ok = 'ok',

  /** Indicates a warning state, where attention is required but not critical. */
  warning = 'warning',

  /** Represents an error state, indicating a failure or issue. */
  error = 'error',

  /** Shows that a process or operation is pending and has not started. */
  pending = 'pending',

  /** Indicates that a process or operation is currently running. */
  running = 'running',

  /** Represents an aborted state, indicating the process was stopped or cancelled. */
  aborted = 'aborted',
}
